<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="showDialog"
      width="800px"
      @close="closeDialog"
      :close-on-click-modal="false" :modal="false"
      append-to-body
    >
      <div style="height: 420px;overflow-x: auto" class="rule-div">
        <!--collapse 面板-->
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item v-for="(item,index) in tags" :key="index" :name="`item-`+index">
            <template slot="title">
              {{item.tagName}}<i class="el-icon-delete" style="margin-left: 10px" title="删除标签" @click.stop="deleteTag(item)"></i>
            </template>
            <div style="width: 100%">
              <div style="width: 50%;float: left;margin-bottom: 10px;">
                <label style="line-height: 1.8"><span style="color: red;padding-right: 2px">*</span>标签名称：</label>
                <el-input size="small" v-model="item.tagName" style="width: 75%"></el-input>
              </div>
              <div style="width: 50%;float: left;padding-left: 30px;margin-bottom: 10px;">
                <el-button type="primary" size="small" @click.stop="handleAddRule(item.rules)">添加或规则</el-button>
                <el-button type="success" size="small" @click.stop="handleSaveTag(item)">保存</el-button>
              </div>
              <div style="width: 100%;float: left;margin-bottom: 10px;">
                <label style="line-height: 1.8">&nbsp;标签备注：</label>
                <el-input type="textarea" rows="1" placeholder="请输入备注" autosize size="small" v-model="item.remark" style="width: 90%"></el-input>
              </div>
              <div style="width:100%;">
                <template v-for="(rule,index) in item.rules">
                  <el-button type="danger" size="small" style="float: right;margin-bottom: 5px;margin-left: 5px" :key="`deleteButton`+index" @click="handleDeleteORRule(item.rules,rule)">删除规则</el-button>
                  <el-button type="primary" size="small" style="float: right;margin-bottom: 5px;" :key="`andButton`+index" @click="handleAddAndRule(rule.rules)">添加与规则</el-button>

                  <el-table
                    :data="rule.rules"
                    :key="`table`+index"
                    border
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                      label="字段">
                      <template slot-scope="scope">
                        <el-select
                          size="small"
                          placeholder="字段名"
                          v-model="scope.row.ruleField"
                          :popper-append-to-body="false"
                          @change="changeField(scope.row)"
                        >
                          <el-option v-for="(field,findex) in fieldList" :key="findex" :value="field.value" :label="field.label"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="规则">
                      <template slot-scope="scope">
                        <el-select
                          size="small"
                          placeholder="规则"
                          v-model="scope.row.ruleSymbol"
                          v-if="scope.row.ruleField !== 'transfer'"
                          :popper-append-to-body="false"
                          :disabled="scope.row.ruleField === 'trigger_node'"
                        >
                          <el-option v-for="(symbol,sindex) in symbolList" :key="sindex" :value="symbol.value" :label="symbol.label"></el-option>
                        </el-select>
                        <!--转接-->
                        <el-select
                          size="small"
                          placeholder="规则"
                          v-model="scope.row.ruleSymbol"
                          v-if="scope.row.ruleField === 'transfer'"
                          :popper-append-to-body="false"
                          @change="changeSymbol(scope.row)"
                        >
                          <el-option v-for="(item,tindex) in transfer" :key="`transfer`+tindex" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="值">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.ruleValue" :class="{'value-width':scope.row.ruleField==='recognize_rate'}" :placeholder="`值，`+placeHolder" size="small" v-if="scope.row.ruleField === 'talk_count' || scope.row.ruleField === 'talk_time' || scope.row.ruleField === 'recognize_rate'"></el-input>

                        <el-tooltip slot="label" v-if="scope.row.ruleField === 'recognize_rate'" effect="light" placement="top">
                          <div slot="content">
                            {{rateTips}}
                          </div>
                          <img class="transfer-tip" :src="questionMark"/>
                        </el-tooltip>

                        <!--触发节点-->
                        <el-select
                          size="small"
                          placeholder="节点"
                          v-model="scope.row.ruleValue"
                          v-if="scope.row.ruleField === 'trigger_node'"
                          :popper-append-to-body="false"
                        >
                          <el-option v-for="(node,nindex) in nodes" :key="`node`+nindex" :value="node.id+''" :label="node.rsName"></el-option>
                        </el-select>
                        <!--转接外线-->
                        <el-select
                          size="small"
                          placeholder="转接外线"
                          style="width: 85%;"
                          v-model="scope.row.ruleValue"
                          :popper-append-to-body="false"
                          v-if="scope.row.ruleField === 'transfer' && scope.row.ruleSymbol === 'transferCall'"
                        >
                          <el-option v-for="(call,cindex) in calls" :key="`transfer`+cindex" :value="call.value" :label="call.value"></el-option>
                        </el-select>
                        <!--转接IVR-->
                        <el-select
                          size="small"
                          placeholder="转接IVR"
                          style="width: 85%;"
                          v-model="scope.row.ruleValue"
                          :popper-append-to-body="false"
                          v-if="scope.row.ruleField === 'transfer' && scope.row.ruleSymbol === 'transferIVR'"
                        >
                          <el-option v-for="(ivr,iindex) in ivrs" :key="`transfer`+iindex" :value="ivr.value" :label="ivr.name"></el-option>
                        </el-select>
                        <!--转接技能组-->
                        <el-select
                          size="small"
                          style="width: 85%;"
                          placeholder="转接技能组"
                          v-model="scope.row.ruleValue"
                          :popper-append-to-body="false"
                          v-if="scope.row.ruleField === 'transfer' && scope.row.ruleSymbol === 'transferQueue'"
                        >
                          <el-option v-for="(queue,qindex) in queues" :key="`transfer`+qindex" :value="queue.value" :label="queue.name"></el-option>
                        </el-select>

                        <!--tips-->
                        <el-tooltip slot="label" v-if="scope.row.ruleField === 'transfer'" effect="light" placement="top">
                          <div slot="content">
                            {{tipsContent}}
                          </div>
                          <img class="transfer-tip" :src="questionMark"/>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="80"
                      label="操作">
                      <template slot-scope="scope">
                        <el-button @click="handleDeleteRule(rule.rules,scope.row)" size="small" type="danger">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-divider :key="`divider`+index" v-if="index+1!=item.rules.length">OR</el-divider>
                </template>
              </div>
            </div>

          </el-collapse-item>
        </el-collapse>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="addTag" size="small" >添加标签</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AITagPop',
  props:['show','flowId'],
  data() {
    return {
      title: 'AI客户标签',
      showDialog: false,
      activeNames:[],
      fieldList:[
        {id:'1',label:'交互轮次',value:'talk_count'},
        {id:'2',label:'通话时长',value:'talk_time'},
        {id:'3',label:'触发节点',value:'trigger_node'},
        {id:'4',label:'识别率',value:'recognize_rate'},
        {id:'5',label:'转接',value:'transfer'}
        ],
      symbolList:[
        {id:'1',label:'大于',value:'>'},
        {id:'1',label:'大于等于',value:'>='},
        {id:'1',label:'小于',value:'<'},
        {id:'1',label:'小于等于',value:'<='},
        {id:'1',label:'等于',value:'='},
      ],
      transfer:[
        {id:'1',label:'外线',value:'transferCall'},
        {id:'2',label:'IVR',value:'transferIVR'},
        {id:'3',label:'技能组',value:'transferQueue'},
      ],
      tags:[],
      nodes:[],
      ivrs:[],
      calls:[],
      queues:[],
      menuId:'',
      journalType:'',
      tagOrIds:[],
      detailIds:[],
      placeHolder:'单位：轮',
      tipsContent:'转接的值是该流程下已配置的值，如外线是该流程下配置的外线',
      rateTips:'识别率计算公式：识别率=识别的节点/语音交互节点总和',
      questionMark:require('../../assets/image/homeAsk.png'),
    }
  },
  methods:{
    initData(){
      this.detailIds=[]
      this.tagOrIds=[]
      let param = {
        rwId:this.flowId
      }
      let that = this
      this.$http.post('/AI/customTag/queryAllTags',param).then(res=>{
        let response = res.data
        if (response.flag !== '666') {
          that.$Message.warning('加载数据错误！')
          return
        }
        that.tags = response.obj
        if (Array.isArray(that.tags) && that.tags.length > 0) {
          for (let i = 0; i < that.tags.length; i++) {
            let tagRules = that.tags[i].rules
            let arr = []
            if (tagRules.length > 0) {
              for (let k = 0; k < tagRules.length; k++) {
                let rul = tagRules[k]
                if (arr.length === 0) {
                  let rArr = []
                  rArr.push(rul)
                  let json = {id: rul.tagOrId, rules: rArr}
                  arr.push(json)
                } else {
                  let orId = rul.tagOrId
                  let push = true
                  for (let j = 0; j < arr.length; j++) {
                    let ar = arr[j]
                    if (ar.id === orId){
                      ar.rules.push(rul)
                      push = false
                      break
                    }
                  }
                  if (push) {
                    let rArr = []
                    rArr.push(rul)
                    let json = {id: rul.tagOrId, rules: rArr}
                    arr.push(json)
                  }
                }
              }
            }
            that.tags[i].rules = arr
          }
        }
      })
    },
    initParamData() {
      let param = {
        rwId:this.flowId
      }
      let that = this
      this.$http.post('/AI/customTag/transferData',param).then(res=>{
        let response = res.data
        if (response.flag !== '666') {
          console.log('load ai transfer data error,message:',response.msg)
          return
        }
        that.ivrs = response.obj.ivrs
        that.calls = response.obj.calls
        that.queues = response.obj.queues
      })
    },
    initNodeData() {
      let param = {
        rwId:this.flowId
      }
      let that = this
      this.$http.post('/AI/customTag/nodes',param).then(res=>{
        let response = res.data
        if (response.flag !== '666') {
          console.log('load ai node error, message :',response.msg)
          return
        }
        that.nodes = response.obj
      })
    },
    closeDialog() {
      this.$emit('closeDialog',true)
    },
    handleChange() {

    },
    addTag() {
      let length = this.tags.length+1
      let json = {
        id:'',
        rwId:this.flowId,
        tagName:'label'+length,
        remark:' ',
        rules:[]
      }
      this.tags.push(json)
    },
    deleteTag(item) {
      let that = this
      this.menuId = 'a_2-3'
      this.journalType = 'AI流程管理=>分类=>删除AI标签'
      this.$Modal.confirm({
        title:'提示',
        content:'删除该标签，会删除话单中标签，是否确认删除？',
        onOk:()=>{
          if(!item.id){
            let index = that.tags.indexOf(item)
            if (index > -1) {
              that.tags.splice(index,1)
              that.$Message.success('删除成功')
            }
          return
          }
          let param = {
            tagId:item.id,
            tagName:item.tagName,
            rwId:that.flowId,
            menuId:that.menuId,
            journalType:that.journalType
          }
          that.$http.post('/AI/customTag/deleteTag',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              that.$Message.error('删除失败')
              console.log('delete tag error:',response.msg)
              return
            }
            that.$Message.success('删除成功')
            that.initData()
          })
        },
        onCancel:()=>{
          console.log(' cancel delete tag')
        }
      })

    },
    handleSaveTag(item){
      this.menuId = 'a_2-3'
      this.journalType = 'AI流程管理=>分类=>保存AI标签'
      let arr = []
      for (let i = 0; i < item.rules.length; i++) {
        arr.push({id:item.rules[i].id,rules:JSON.stringify(item.rules[i].rules)})
      }
      let param = {
        menuId:this.menuId,
        journalType:this.journalType,
        tagOrIds: JSON.stringify(this.tagOrIds),
        detailIds: JSON.stringify(this.detailIds),
        id:item.id,
        rwId:this.flowId,
        tagName:item.tagName,
        remark:item.remark,
        ruleOrs:JSON.stringify(arr)
      }
      let that = this
      this.$http.post('/AI/customTag/saveTag',param).then(res=>{
        let response = res.data
        if (response.flag !== '666') {
          that.$Message.error('保存标签失败！')
          console.log('save tag error:', response.msg)
          return
        }
        that.$Message.success('保存标签成功！')
        that.initData()
      })
    },
    handleDeleteRule(tag,rule) {
      let that = this
      this.$Modal.confirm({
        title:'提示',
        content:'是否确认删除',
        onOk:()=>{
          let rules = tag
          if (!Array.isArray(rules) || rules.length <= 0) {
            return
          }
          let index = rules.indexOf(rule)
          if (index > -1) {
            if (rule.id) {
              this.detailIds.push(rule.id+'')
            }
            tag.splice(index,1)
          }
        },
        onCancel:()=>{
          console.log(' cancel delete tag')
        }
      })

    },
    handleAddRule(ruleTables) {
      let json = {
        id:'',
        rules:[],
        key:Date.now()
      }
      ruleTables.push(json)
    },
    handleAddAndRule(rules) {
      let json = {
        id: '',
        ruleField:'talk_count',
        ruleSymbol:'>',
        ruleValue:'',
        key:Date.now()
      }
      rules.push(json)
    },
    handleDeleteORRule(ruleTables,rules) {
      let that = this
      this.$Modal.confirm({
        title:'提示',
        content:'是否确认删除',
        onOk:()=>{
          if (!Array.isArray(ruleTables) || ruleTables.length <= 0) {
            return
          }
          let index = ruleTables.indexOf(rules)
          if (index > -1) {
            if (rules.id) {
              this.tagOrIds.push(rules.id+'')
            }
            ruleTables.splice(index,1)
          }
        },
        onCancel:()=>{
          console.log(' cancel delete tag')
        }
      })
    },
    changeField(row) {
      switch (row.ruleField) {
        case 'talk_count':
          row.ruleSymbol = '>'
          row.ruleValue = ''
          this.placeHolder = '单位：轮'
          break;
        case 'trigger_node':
          row.ruleSymbol = '='
          row.ruleValue = ''
          break
        case 'transfer':
          row.ruleSymbol = 'transferCall'
          row.ruleValue = ''
          break
        case 'talk_time':
          row.ruleSymbol = '>'
          row.ruleValue = ''
          this.placeHolder = '单位：秒'
          break
        case 'recognize_rate':
          row.ruleSymbol = '>'
          row.ruleValue = ''
          this.placeHolder = '单位：百分比，如:55.00'
          break
        default:
          break
      }
    },
    changeSymbol(row) {
      if (row.ruleField === 'transfer') {
        let value = ''
        if (row.ruleSymbol === 'transferCall') {
          if (this.calls.length > 0) {
            value = this.calls[0].value
          }
        }else if (row.ruleSymbol === 'transferIVR') {
          if (this.ivrs.length > 0) {
            value = this.ivrs[0].value
          }
        } else if (row.ruleSymbol === 'transferQueue') {
          if (this.queues.length > 0) {
            value = this.queues[0].value
          }
        }
        row.ruleValue = value
      }
    }
  },
  watch:{
    show:{
      deep:true,
      immediate:true,
      async handler(value) {
        this.showDialog = value
        if (value) {
          this.tags = []
          this.activeNames=[]
          await this.initParamData()
          await this.initNodeData()
          this.initData()
        }
      }
    }
  }
}
</script>

<style lang="css">
  .zZindex{
    z-index: 5000!important;
  }
  .rule-div{

  }
  .value-width{
    width: 85%;
  }
  .transfer-tip{
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    float: right;
    margin-top: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/aiManager/AITagPop.vue